import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { PermissionListResponse } from '../../responses/platform/permission.response';

@Injectable({ providedIn: 'root' })
export class PermissionService extends CommonService {
  private base = environment.urlApiPlatform + 'Permission/';
  constructor(private http: HttpClient) { super(); }

  /** Lista de permissões (ajuste o endpoint se necessário) */
  public list(): Observable<PermissionListResponse> {
    return this.http
      .get<PermissionListResponse>(this.base + 'list', this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
